import {PaymentElement} from '@stripe/react-stripe-js';
import Button from '@mui/material/Button';
import { Stack } from '@mui/material';
import {useStripe, useElements} from '@stripe/react-stripe-js';
import { useSelector } from 'react-redux';
import { useState, useRef } from 'react';
import Box from '@mui/material/Box';
import ResultSend from '../alert/ResultSend';
import Translation from '../../utils/Translation';

const CheckoutForm = ({handleClose,AcceptOfferAfterPayment}) => {

const stripe = useStripe();
const elements = useElements();
const {offerIdx} = useSelector(state => state.request);
const [error, setError] = useState(null);
const [isSubmitting, setIsSubmitting] = useState(false);
const submittingRef = useRef(false);

    const handleSubmit = async (event) => {
        // We don't want to let default form submission happen here,
        // which would refresh the page.
        event.preventDefault();
    

        if (!stripe || !elements) {
          // Stripe.js hasn't yet loaded.
          // Make sure to disable form submission until Stripe.js has loaded.
          return;
        }
    
        if (submittingRef.current) return;
        submittingRef.current = true;
        setIsSubmitting(true);
        setError(null);
        try {
          const result = await stripe.confirmPayment({
            elements,
            confirmParams: { return_url: window.location.href },
            redirect: 'if_required',
          });
          if (result.error) {
            setError(result.error.message);
          } else if (['succeeded', 'requires_capture'].includes(result.paymentIntent?.status)) {
            await AcceptOfferAfterPayment(offerIdx);
            handleClose();
          } else {
            setError('Payment is not confirmed yet. Please wait and try again.');
          }
        } catch (error) {
          setError(error?.message || 'Unable to confirm payment. Please try again.');
        } finally {
          submittingRef.current = false;
          setIsSubmitting(false);
        }
      };

  return (
    <form onSubmit={(event)=>handleSubmit(event)}>
      <PaymentElement />

      {error &&
        <Box className="pt-2">
            <ResultSend msg={error}  error={error?true:false} />
        </Box>
       }

      
      <Stack direction="row" spacing={2} className='mt-2'>
                          
        <Button variant="contained" className='font-weight-600' type='submit' disabled={!stripe || !elements || isSubmitting}>
             <Translation  data="request.payment"  />
        </Button>
        <Button variant="outlined" className='font-weight-600 button-outlined' onClick={handleClose} disabled={isSubmitting}>
            <Translation  data="request.cancel"  />
        </Button>

       </Stack>
    </form>
  )
};

export default CheckoutForm;
